import { call, put, takeEvery } from 'redux-saga/effects';
import { fetchDatasetStatusError, fetchDatasetStatusSuccess } from '../actions';
import actions from '../constants';
import DatasetStatusService from '../service';

function fetchDatasetStatus(code) {
  return DatasetStatusService.status(code)
    .then((response) => ({ response }))
    .catch((error) => ({ error }));
}

export function* status(action) {
  const { response, error } = yield call(fetchDatasetStatus, action.code);
  if (error) {
    yield put(fetchDatasetStatusError(action.code, error));
  } else {
    yield put(fetchDatasetStatusSuccess(action.code, response));
  }
}

export default function* datasetStatusApi() {
  yield takeEvery(actions.FETCH_DATASET_STATUS, status);
}
